<template>
  <div class="mar-bottom-15 shadow radiusCard remove-margin">
    <div class="cardIn p-d-8" @click="detailTraining(id_Training)">
      <div class="d-flex-between-center p-t-12">
        <p class="f-Overpass f-14 remove-margin">{{ id_Training }}</p>
        <div class="d-flex">
          <p
            :class="'f-12 f-Overpass f-c-midgrey remove-margin ' + status_css"
            style="padding: 3px"
          >
            {{ status_fix }}
          </p>
          <!-- <i class="fas fa-chevron-right f-c-midgrey"></i> -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
              fill="#6F7287"
            />
          </svg>
        </div>
      </div>
      <p class="f-Overpass f-16 f-bold p-d-4 remove-margin">
        {{ jenis_Training }}
      </p>
      <div class="d-flex p-d-12">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          class="mar-right-4"
        >
          <g clip-path="url(#clip0_1565_14268)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.00033 2C4.68662 2 2.00033 4.68629 2.00033 8C2.00033 11.3137 4.68662 14 8.00033 14C11.314 14 14.0003 11.3137 14.0003 8C14.0003 4.68629 11.314 2 8.00033 2ZM0.666992 8C0.666992 3.94991 3.95024 0.666669 8.00033 0.666669C12.0504 0.666669 15.3337 3.94991 15.3337 8C15.3337 12.0501 12.0504 15.3333 8.00033 15.3333C3.95024 15.3333 0.666992 12.0501 0.666992 8ZM8.00024 3.33333C8.36843 3.33333 8.6669 3.63181 8.6669 4V7.58798L10.965 8.73705C11.2944 8.90171 11.4278 9.30216 11.2632 9.63148C11.0985 9.96079 10.6981 10.0943 10.3688 9.92962L7.7021 8.59628C7.47624 8.48336 7.33357 8.25251 7.33357 8V4C7.33357 3.63181 7.63205 3.33333 8.00024 3.33333Z"
              fill="#808080"
            />
          </g>
          <defs>
            <clipPath id="clip0_1565_14268">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <p class="f-c-midgrey f-12 f-Overpass remove-margin">
          {{ jadwal_Training }}
          {{
            jenis_Training == "Training Berbayar Online"
              ? "| " + jadwal_Training_2
              : ""
          }}
        </p>
      </div>
      <template
        v-if="
          status_Training == '60_menunggu_pembayaran' &&
          timeStep != 'Waktu Habis'
        "
      >
        <div class="bg-grey d-flex-between-center p-x-8 pad-5 radiusPembayaran">
          <p class="f-c-midgrey f-14 remove-margin">Batas Waktu Pembayaran</p>
          <p class="f-c-red f-14 f-bold remove-margin">
            {{ timeStep }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListTraining",
  props: {
    id_Training: "",
    status_Training: "",
    jenis_Training: "",
    jadwal_Training: "",
    jadwal_Training_2: "",
    batas_pembayaran: "",
  },
  data() {
    return {
      timeStep: "",
      timeInterval: null,
    };
  },
  computed: {
    status_fix() {
      let text = this.status_Training;
      let result = text.replace(/_/gi, " ");
      let parts = result.split(" ");
      let parts_slice = parts.slice(1);
      let capitalize = parts_slice.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      let join = capitalize.join(" ");
      return `${join}`;
    },

    status_css() {
      let text = this.status_Training;
      let result = text.replace("_", "");
      let cls_css = result.replace(/^.{2}/g, "");
      return `${cls_css}`;
    },
  },

  mounted() {
    this.countdownStart();
  },

  methods: {
    countdown() {
      let timeEnd = new Date(this.batas_pembayaran).getTime();
      let timeNow = new Date().getTime();
      let distance = timeEnd - timeNow;

      if (distance < 0) {
        clearInterval(this.timeInterval);
        this.timeStep = "Waktu Habis";
        return;
      }

      let minutes = String(
        Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      ).padStart(2, "0");
      let seconds = String(
        Math.floor((distance % (1000 * 60)) / 1000)
      ).padStart(2, "0");

      this.timeStep = minutes + ":" + seconds;
    },

    countdownStart() {
      this.timeInterval = setInterval(this.countdown, 1000);
      this.countdown();
    },

    detailTraining(param_IdTraining) {
      this.$router.push({
        name: "detailTraining",
        params: { idtraining: param_IdTraining },
      });
    },
  },
};
</script>

<style scoped>
.link-tagihan {
  text-decoration: none;
}
.cardIn {
  background-color: #fff;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 7px;
}
.dibatalkan_oleh_cs {
  background-color: #da1e28;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
  color: #fff;
}
.dijadwalkan_ulang {
  background-color: #fff1f1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.terjadwalkan {
  background-color: #fceeff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_konfirmasi_cs {
  background-color: #fff8e1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}
.menunggu_pembayaran {
  background-color: #e2f0ff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}

.selesai {
  background-color: #e2f0ff;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}

.pembayaran_gagal {
  background-color: #fff1f1;
  padding: 3px;
  width: fit-content;
  border-radius: 3px;
}

.radiusPembayaran {
  border-radius: 4px;
}

.radiusCard {
  border-radius: 7px;
}
</style>
